(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Intervallo tra una scheda e la successiva.
    const intervalloAutoplay = 4500;

    const avviaAutoplay = () => {
      document
        .querySelectorAll(
          '[data-testid="collections-list-grid"] .resource-list__carousel'
        )
        .forEach((carosello) => {
          // Evita timer duplicati durante i ricaricamenti dell’editor.
          if (carosello.dataset.autoplayAttivo === 'true') return;

          const scorrimento = carosello.querySelector('slideshow-slides');

          const frecciaSuccessiva = carosello.querySelector(
            'slideshow-arrows .slideshow-control--next, ' +
            '.slideshow-control--next'
          );

          // Senza contenitore scorrevole non inizializza il timer.
          if (!scorrimento) return;

          // Segna il carosello come già inizializzato.
          carosello.dataset.autoplayAttivo = 'true';

          // Fa avanzare automaticamente il carosello su mobile e desktop.
          window.setInterval(() => {
            // Sospende l’avanzamento se la pagina non è visibile.
            if (document.hidden) return;

            const fineCarosello =
              scorrimento.scrollLeft + scorrimento.clientWidth >=
              scorrimento.scrollWidth - 4;

            const frecciaDisabilitata =
              frecciaSuccessiva?.disabled ||
              frecciaSuccessiva?.getAttribute('aria-disabled') === 'true';

            if (frecciaSuccessiva && !frecciaDisabilitata) {
              // Usa la navigazione nativa del tema.
              frecciaSuccessiva.click();
            } else if (fineCarosello) {
              // Torna alla prima scheda quando raggiunge la fine.
              scorrimento.scrollTo({
                left: 0,
                behavior: 'smooth'
              });
            } else {
              // Fallback per i caroselli senza frecce visibili.
              scorrimento.scrollBy({
                left: scorrimento.clientWidth,
                behavior: 'smooth'
              });
            }
          }, intervalloAutoplay);
        });
    };

    // Avvia subito l’autoplay.
    avviaAutoplay();

    // Riavvia il controllo quando l’editor aggiorna la sezione.
    const osservatore = new MutationObserver(avviaAutoplay);

    osservatore.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
